<template>

    <v-menu
        ref="menu"
        v-model="menu"
        :return-value.sync="inputVal"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-x
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">

            <v-text-field
                v-model="inputVal"
                :label="label"
                :prepend-icon="icon"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                color="white"
            ></v-text-field>

        </template>

        <v-date-picker
            v-model="inputVal"
            no-title
            scrollable
            :type="type"
            :allowed-dates="val => allowedDates.indexOf(val) !== -1"
            :min="min"
            :max="max"
            >

            <v-spacer></v-spacer>

        </v-date-picker>

    </v-menu>

</template>

<script>

    export default {

        props: {
            allowedDates : {
                type : Array,
                default: [],
            },

            type : {
               type : String,
               default: 'date', 
            },

            value: {
                type: String,
                default: null,
            },
            label : {
                type: String,
                default: 'date',
            },
            min : {
                type: String,
                default : null,
            },
            
            max : {
                type: String,
                default : null,
            },
            icon : {
                type: String,
                default: 'mdi-calendar'
            }
        },

        data() {

            return {
                menu: false,
            }

        },

        watch: {
            menu: function(val)
            {
                if(val == false)
                    this.$refs.menu.save(this.inputVal)
            },

            inputVal: function(val)
            {
                this.$emit('change', val);
            }
        },

        computed: {
            inputVal: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.menu = false;
                    this.$emit('input', val);
                }
            }
        }

    }
</script>